"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domingEffect = domingEffect;
var _createCanvas = require("../Utils/createCanvas");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function domingEffect(srcCanvas) {
  var shadows = [{
    blur: "2px",
    color: "rgba(0, 0, 0, 0.5)",
    offsetX: "0",
    offsetY: "0"
  }, {
    blur: "5px",
    color: "rgba(0, 0, 0, 0.5)",
    offsetX: "0",
    offsetY: "0"
  }, {
    blur: "10px",
    color: "rgba(0, 0, 0, 0.5)",
    offsetX: "0",
    offsetY: "0"
  }, {
    blur: "20px",
    color: "rgba(0, 0, 0, 0.5)",
    offsetX: "0",
    offsetY: "0"
  }, {
    blur: "30px",
    color: "rgba(0, 0, 0, 0.5)",
    offsetX: "0",
    offsetY: "0"
  }];
  modifyImage(srcCanvas, shadows);
}
function invertColor(color) {
  var colorArray = color.replace(/[^\d,.]/g, "").split(",");
  var inverted = [];
  for (var k = 0; k < colorArray.length; k++) {
    inverted[k] = 255 - colorArray[k];
  }
  return "rgb(".concat(inverted[0], ",").concat(inverted[1], ",").concat(inverted[2], ",").concat(colorArray[3], ")");
}
var createDropShadow = function createDropShadow(_ref) {
  var offsetX = _ref.offsetX,
    offsetY = _ref.offsetY,
    blur = _ref.blur,
    color = _ref.color;
  return "drop-shadow(".concat([offsetX, offsetY, blur, color].join(" "), ")");
};
function modifyImage(srcCanvas, shadows) {
  if (!shadows || shadows.length === 0) {
    // eslint-disable-next-line no-console
    console.warn("Could not apply effect, shadows has to be provided!");
    return;
  }
  var _createWorkingCanvas = (0, _createCanvas.createWorkingCanvas)(srcCanvas),
    _createWorkingCanvas2 = _slicedToArray(_createWorkingCanvas, 2),
    imageCanvas = _createWorkingCanvas2[0],
    ctx = _createWorkingCanvas2[1];
  ctx.drawImage(srcCanvas, 0, 0);
  var width = imageCanvas.width,
    height = imageCanvas.height;
  var diagonal = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
  var rectHeight = width * height / diagonal / diagonal;
  var gradient = ctx.createLinearGradient(0, 0, height, width);
  gradient.addColorStop(0, "rgba(0,0,0,0)");
  gradient.addColorStop(rectHeight - 0.005, "rgba(0,0,0,0)");
  gradient.addColorStop(1, "rgba(0,0,0,1)");
  var _createWorkingCanvas3 = (0, _createCanvas.createWorkingCanvas)(imageCanvas),
    _createWorkingCanvas4 = _slicedToArray(_createWorkingCanvas3, 2),
    shadowCanvas = _createWorkingCanvas4[0],
    shadowContext = _createWorkingCanvas4[1];
  shadowContext.strokeStyle = gradient;
  shadowContext.lineWidth = 8;
  shadowContext.strokeRect(0, 0, width, height);
  for (var i = 0; i < shadows.length; i++) {
    shadowContext.filter = createDropShadow(shadows[i]);
    shadowContext.drawImage(shadowCanvas, 0, 0);
    ctx.drawImage(shadowCanvas, 0, 0);
  }
  var gradient2 = ctx.createLinearGradient(0, 0, height, width);
  gradient2.addColorStop(0, "rgba(255,255,255,1)");
  gradient2.addColorStop(rectHeight + 0.005, "rgba(255,255,255,0)");
  gradient2.addColorStop(1, "rgba(255,255,255,0)");
  var _createWorkingCanvas5 = (0, _createCanvas.createWorkingCanvas)(imageCanvas),
    _createWorkingCanvas6 = _slicedToArray(_createWorkingCanvas5, 2),
    shadowCanvas2 = _createWorkingCanvas6[0],
    shadowContext2 = _createWorkingCanvas6[1];
  shadowContext2.strokeStyle = gradient2;
  shadowContext2.lineWidth = 8;
  shadowContext2.strokeRect(0, 0, width, height);
  for (var _i = 0; _i < shadows.length; _i++) {
    var invertedColor = invertColor(shadows[_i].color);
    shadowContext2.filter = createDropShadow(_objectSpread(_objectSpread({}, shadows[_i]), {}, {
      color: invertedColor
    }));
    shadowContext2.drawImage(shadowCanvas2, 0, 0);
    ctx.drawImage(shadowCanvas2, 0, 0);
  }
  var _createWorkingCanvas7 = (0, _createCanvas.createWorkingCanvas)(imageCanvas),
    _createWorkingCanvas8 = _slicedToArray(_createWorkingCanvas7, 2),
    lighterCanvas = _createWorkingCanvas8[0],
    lighterContext = _createWorkingCanvas8[1];
  lighterContext.fillStyle = "rgba(0,0,0,0.1)";
  lighterContext.fillRect(0, 0, width, height);
  ctx.globalCompositeOperation = "destination-out";
  ctx.drawImage(lighterCanvas, 0, 0);

  // copy the created image over the src canvas
  var srcCtx = srcCanvas.getContext("2d");
  srcCtx.clearRect(0, 0, width, height);
  srcCtx.drawImage(imageCanvas, 0, 0);
}